import React, { useCallback, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Tooltip } from '@mui/material';

// project import
import { FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons';
import { ThemeMode } from '../../../../config';

// assets
import IconButton from '../../../../components/@extended/IconButton';

// ==============================|| HEADER CONTENT - FULLSCREEN ||============================== //

const FullScreen = () => {
  const theme = useTheme();

  const [open, setOpen] = useState(false);
  const handleToggle = useCallback(() => {
    setOpen(prevOpen => !prevOpen);
    if (document && !document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }, []);

  const iconBackColorOpen =
    theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'grey.100';
  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <Tooltip title={open ? 'Exit Fullscreen' : 'Fullscreen'}>
        <IconButton
          color="secondary"
          variant="light"
          sx={{
            color: 'text.primary',
            bgcolor: open ? iconBackColorOpen : 'transparent',
          }}
          aria-label="fullscreen toggler"
          onClick={handleToggle}>
          {open ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default FullScreen;
